import React from "react";

const Download  = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M19.6 15.062h8L18 24.543l-9.6-9.481h8V4h3.2v11.062zM5.2 29.284h25.6V18.222H34v12.642c0 .42-.169.821-.469 1.118a1.61 1.61 0 01-1.131.462H3.6a1.61 1.61 0 01-1.131-.462A1.57 1.57 0 012 30.864V18.222h3.2v11.062z"
          fill={fill}
      />
    </svg>
);

export default Download;
